import * as Yup from "yup";

export const LoginForm = Yup.object().shape({
  phone: Yup.string().required("Phone Number Is Required"),
});

export const EditProfileForm = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  name_ar: Yup.string().required("Arabic Name is required"),
  mobile: Yup.number()
    .typeError("Mobile number should be a Number")
    .required("Mobile number is required"),
  alernativemobile: Yup.number()
    .typeError("Alternative number should be a Number")
    .required("Alternative Number is required"),
  dob: Yup.string().required("DOB is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  address: Yup.string().required("Address is required"),
  country: Yup.string().required("Country is required"),
  // state: Yup.string().required("State is required"),
  nationality: Yup.string().required("Nationality is required"),
  maritalStatus: Yup.string().required("Marital Status is required"),
  emirateId: Yup.string().required("Emirates ID is required"),
  expiryDate: Yup.string().required("Expiry Date is required"),
});

export const AddFamilModalForm = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  name_ar: Yup.string().required("Arabic Name is required"),
  mobile: Yup.string().required("Mobile No is required"),
  relation: Yup.string().required("Relation is required"),
  dob: Yup.string().required("DOB is required"),
  expiryDate: Yup.date().nullable().required("Expiry Date is required"),
  expiryNo: Yup.string().required("Emirate Id is required"),
});

export const EditFamilyProfileForm = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  name_ar: Yup.string().required("Arabic Name is required"),
  mobile: Yup.number()
    .typeError("Mobile number should be a Number")
    .required("Mobile number is required"),
  dob: Yup.string().required("DOB is required"),
  relation: Yup.string().required("Relation is required"),
  expiryNo: Yup.string().required("ExpiryId is required"),
  // uploadDocs: Yup.string().required("ExpiryId is required"),
  expiryDate: Yup.string().required("Expiry Date is required"),
});

export const EarlyLevae = Yup.object().shape({
  startDate: Yup.string().required("Date is required"),
  time: Yup.string().required("Out Time is required"),
  inTime: Yup.string().required("In Time is Required"),
});

export const Complaints = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is Required"),
});

export const LostAndFound = Yup.object().shape({
  title: Yup.string().required("Title is required"),

  school: Yup.string().required("School is required"),

  date: Yup.string().required("Date is required"),
  where: Yup.string().required("Where is required"),
});
export const AddNoteVal = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Please enter the description"),
});

export const Reschduleval = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  scheduleTime: Yup.string().required("Please enter the Schdeule Time"),
});
export const RewardVal = Yup.object().shape({
  points: Yup.number()
    .required(" The number is required!")
    .test(
      "Is positive?",
      "ERROR: The number must be greater than 0!",
      (value) => value > 0
    ),
  title: Yup.string().required("Title is required"),
});
export const LeaveRequest = Yup.object().shape({
  leavetype: Yup.string().required("Leave type is required"),
  startDate: Yup.string().required("Leave StartDate is required"),
  endDate: Yup.string().required("Leave EndDate is required"),
});

export const noteBookListSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  title: Yup.string().required("Title is required"),
  recomnedation: Yup.string().required("Recomnedation is required"),
  date: Yup.date().required("Date is required"),
  subject: Yup.string().required("Subject is required"),
});

export const Elibrary = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  subject: Yup.string().required("Subject is required"),
  // class: Yup.string().required("class is required"),
  category: Yup.string().required("category is required"),
  term: Yup.string().required("term is required"),
});

export const addScheduleMeetingSchema = Yup.object().shape({
  school: Yup.string().required("School is required"),
  // role: Yup.string().required("Role is required"),
  meetingType: Yup.string().required("Meeting Type is required"),
  date: Yup.date().required("Date is required"),
  scheduleTime: Yup.date().required("Meeting Time is required"),
});

export const CreateAssignemntSchema = Yup.object().shape({
  school: Yup.string().required("School is required"),
  title: Yup.string().required("Title is required"),
  assigntype: Yup.string().required("Assignment Type is required"),
  assignmentno: Yup.string().required("Assignment No is required"),
  postdate: Yup.date().required("Assign Date is required"),
  posttime: Yup.date().required("Assign Time is required"),
  submitDate: Yup.date().required("Submit Date is required"),
  submitTime: Yup.date().required("Submit Time is required"),
  duedate: Yup.date().required("Due Date is required"),
});

export const Cardvalidataion = Yup.object().shape({
  cardnumber: Yup.string().required("Card Number is Required").min(13).max(20),
  // .matches(/^4[0-9]{12}(?:[0-9]{3})?$/, "Please Enter Valid Card Number"),
  exp_month: Yup.string()
    .required("Expiry Month is Required")
    .matches(/^(0[1-9]|1[0-2])$/, "Invalid expiry Month"),
  exp_year: Yup.string()
    .required("Expiry Year is Required")
    .matches(/(?:(?:20|20)[0-9]{2})/, "Invalid expiry Year")
    .max(4)
    .min(4),
  cvc: Yup.string().required("CVV is required").max(3).min(3),
});

export const WalletVal = Yup.object().shape({
  amount: Yup.number()
    .required(" The amount is required!")
    .test(
      "Is positive?",
      "The amount must be greater than 0!",
      (value) => value > 0
    ),
});
export const LocationvalidationSchema = Yup.object().shape({
  // location: Yup.string().required("Type Your Location is required"),
  sector: Yup.string().required("Sector is required"),
  areaForTransport: Yup.string().required("Area is required"),
  street: Yup.string().required("Street is required"),
  buildingVilla: Yup.string().required("Building/Villa is required"),
  flat: Yup.string().required("Flat/VillaNo is required"),
  landmark: Yup.string().required("Landmark is required"),
  mobileNumber: Yup.string().required("Mobile Number is required"),
  landlineNumber: Yup.string().required("Landline Number is required"),
  flatPhoto: Yup.string().required("File is required"),
});

export const LocationvalidationSchemaMYLOCATION = Yup.object().shape({
  sector: Yup.string().required("Sector is required"),
  areaForTransport: Yup.string().required("Area is required"),
  street: Yup.string().required("Street is required"),
  buildingVilla: Yup.string().required("Building/Villa is required"),
  flat: Yup.string().required("Flat/VillaNo is required"),
  landmark: Yup.string().required("Landmark is required"),
  mobileNumber: Yup.string().required("Mobile Number is required"),
  landlineNumber: Yup.string().required("Landline Number is required"),
  flatVillaPhoto: Yup.string().required("File is required"),
});

export const LocationvalidationSchemaMYLOCATIONEDIT = Yup.object().shape({
  // location: Yup.string().required("Type Your Location is required"),
  sector: Yup.string().required("Sector is required"),
  areaForTransport: Yup.string().required("Area is required"),
  street: Yup.string().required("Street is required"),
  buildingVilla: Yup.string().required("Building/Villa is required"),
  flat: Yup.string().required("Flat/VillaNo is required"),
  landmark: Yup.string().required("Landmark is required"),
  mobileNumber: Yup.string().required("Mobile Number is required"),
  landlineNumber: Yup.string().required("Landline Number is required"),
});

export const LocationvalidationSchemaEdit = Yup.object().shape({
  location: Yup.string().required("Type Your Location is required"),
  sector: Yup.string().required("Sector is required"),
  areaForTransport: Yup.string().required("Area is required"),
  street: Yup.string().required("Street is required"),
  buildingVilla: Yup.string().required("Building/Villa is required"),
  flat: Yup.string().required("Flat/VillaNo is required"),
  landmark: Yup.string().required("Landmark is required"),
  mobileNumber: Yup.string().required("Mobile Number is required"),
  landlineNumber: Yup.string().required("Landline Number is required"),
});

export const validationSchemas = Yup.object().shape({
  type: Yup.string().required("Please select a question type"),
  subtype: Yup.string().required("Please select a question subtype"),
  // marks: Yup.number().required("Please enter the marks").positive().integer(),
  title: Yup.string().required("Please enter the title"),
  description: Yup.string().required("Please enter the description"),
  // answer: Yup.string().required("Please enter answer as well"),
  // options: Yup.array().of(Yup.string().required("options is required")),

  // mediaFile: Yup.string().required("Please Upload the File"),
  // mulipleansweroption: Yup.array()
  //   .of(Yup.string().required("Option is required"))
  //   .min(1, "At least one field is required"),
  // aswerOption: Yup.string().required("Select The Correct Answer Option"),
});

export const validationSchemasMul = Yup.object().shape({
  type: Yup.string().required("Please select a question type"),
  subtype: Yup.string().required("Please select a question subtype"),
  // marks: Yup.number().required("Please enter the marks").positive().integer(),
  title: Yup.string().required("Please enter the title"),
  description: Yup.string().required("Please enter the description"),
  // options: Yup.array().of(Yup.string().required("options is required")),

  // mediaFile: Yup.string().required("Please Upload the File"),
  // mulipleansweroption: Yup.array()
  //   .of(Yup.string().required("Option is required"))
  //   .min(1, "At least one field is required"),
  //
});
export const FamilyValidation = Yup.object().shape({
  category: Yup.string().required("Please select the category"),
  class: Yup.string().required("Please select the class"),
  section: Yup.string().required("Please select the section"),
  title: Yup.string().required("Please enter the title"),
});

export const AddOnlineRequest = Yup.object().shape({
  school: Yup.string().required("School is required"),
  leaveStartDate: Yup.string().required("Leave start date is required"),
  leaveEndDate: Yup.string().required("Leave end date is required"),
  reason: Yup.string().required("Reason is required"),
});
